import { call, takeEvery } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* listSettings(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SETTINGS.LIST, action.payload, true);
}

function* createSetting(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.SETTINGS.CREATE, action.payload, true);
}

function* updateSetting(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SETTINGS.UPDATE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.PUT, url, rest, true);
}

function* deleteSetting(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SETTINGS.DELETE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.DELETE, url, rest, true);
}

function* listEmailTemplates(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EMAIL_TEMPLATES.LIST, action.payload, true);
}

function* getEmailTemplate(action: any): any {
  const { id } = action.payload || {};
  yield call(sagaFunction, action, CallApi.GET, API_URL.EMAIL_TEMPLATES.GET(id), {}, true);
}

function* updateEmailTemplate(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.EMAIL_TEMPLATES.UPDATE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.PUT, url, rest, true);
}

function* listSubscriptionPlans(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SUBSCRIPTION_PLANS.LIST, action.payload, true);
}

function* updateSubscriptionPlan(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.SUBSCRIPTION_PLANS.UPDATE, action.payload, true);
}

export default function* adminSettingsSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.SETTINGS.LIST, listSettings);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SETTINGS.CREATE, createSetting);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SETTINGS.UPDATE, updateSetting);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SETTINGS.DELETE, deleteSetting);
  yield takeLatest(SAGA_ACTIONS.ADMIN.EMAIL_TEMPLATES.LIST, listEmailTemplates);
  yield takeLatest(SAGA_ACTIONS.ADMIN.EMAIL_TEMPLATES.GET, getEmailTemplate);
  yield takeLatest(SAGA_ACTIONS.ADMIN.EMAIL_TEMPLATES.UPDATE, updateEmailTemplate);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUBSCRIPTION_PLANS.LIST, listSubscriptionPlans);
  yield takeEvery(SAGA_ACTIONS.ADMIN.SUBSCRIPTION_PLANS.UPDATE, updateSubscriptionPlan);
}
